import { render, staticRenderFns } from "./photos-viewer.vue?vue&type=template&id=91e318f8&scoped=true"
import script from "./photos-viewer.vue?vue&type=script&lang=ts"
export * from "./photos-viewer.vue?vue&type=script&lang=ts"
import style0 from "./photos-viewer.vue?vue&type=style&index=0&id=91e318f8&prod&lang=css"
import style1 from "./photos-viewer.vue?vue&type=style&index=1&id=91e318f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e318f8",
  null
  
)

export default component.exports